'use client';
import styled from 'styled-components';
import CardList from '@/ui/CardList';
import { colors, toRgba } from '@/styles';

export const EvaluationsList = styled(CardList)`
  /* background: ${colors.primary.white}; */
`;
